module.exports = __webpack_public_path__ + "img/jokefroglet.95819111.gif";